import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { dashboardReducer } from 'src/slices/dashboardSlice';
import { userReducer as user } from './user/reducers';
import { settingsReducer as settings } from './settings/reducers';

export const reducers = (history: any) =>
  combineReducers({
    router: connectRouter(history),
    user,
    settings,
    dashboard: dashboardReducer,
  });
